import { COLORS } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 20rem;
  display: flex;
  flex-direction: column;
  gap: 15rem;
`;

export const Title = styled.label`
  font-weight: 400;
  font-size: 22rem;
  color: ${COLORS.BLACK};
  text-align: center;
  margin-bottom: 10rem;

  ${respondTo.bigPhone`
    font-size: 20rem;
  `};
`;

export const SectionLabel = styled.label`
  color: ${COLORS.BLACK};
  font-size: 16rem;
  font-weight: 500;
`;

export const HelperText = styled.span`
  color: ${COLORS.BLACK};
  font-size: 15rem;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8rem;
  width: 100%;
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20rem;
  color: ${COLORS.BLACK};
  font-size: 14rem;
  border: 1rem dashed ${COLORS.BORDER};
  border-radius: 8rem;
`;

export const PriceText = styled.span`
  color: ${COLORS.BLACK};
  font-size: 13rem;
`;

export const InlineButtonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const FormColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6rem;
  width: 100%;
`;

export const FieldLabel = styled.label`
  color: ${COLORS.BLACK};
  font-size: 14rem;
`;

export const ErrorMessage = styled.span`
  color: ${COLORS.RED};
  font-size: 12rem;
  min-height: 16rem;
`;

export const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10rem;
  margin-top: 10rem;
`;

export const DefaultDeleteRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const DeleteDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 5rem;
  cursor: pointer;
`;

export const DeleteLabel = styled.span`
  color: ${COLORS.RED};
  font-size: 14rem;
`;

export const FormModalContainer = styled.div`
  padding: 20rem;
  display: flex;
  flex-direction: column;
  gap: 15rem;
`;
